import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class AdminService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async agentByRoleList(data) {
        const pos = getPosition();
        const response = await API.service('agentByRoleList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async agentByUuid(data) {
        const pos = getPosition();
        const response = await API.service('findAgent', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async agentCrmList(data) {
        const pos = getPosition();
        const response = await API.service('agentCrmList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async maxAssignedCrm(data) {
        const pos = getPosition();
        const response = await API.service('updateMaxAssign', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async agentAuthSignature(data) {
        const pos = getPosition();
        const response = await API.service('agentAuthSignature', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async agentByEmail(data) {
        const pos = getPosition();
        const response = await API.service('agentByEmail', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async updateAgent(data) {
        const pos = getPosition();
        const response = await API.service('updateAgent', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async downloadInfo(data) {
        const pos = getPosition();
        const response = await API.service('downloadInfo', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async generateZip(data) {
        const pos = getPosition();
        const response = await API.service('generateZip', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}